import React, {useState} from 'react'

import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import {DealPageRebateItem} from "./DealPageRebateItem";
import {CreateRebateItem} from "./CreateRebateItem";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

import classnames from "classnames";
import Collapse from "@mui/material/Collapse";
import {SectionChevron} from "./SectionChevron";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import {NumericFormat} from "react-number-format";
import {useDealContext} from "../../contexts/DealContext";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import {useFetchHook} from "../../hooks/useFetchHook";
import fetcher from "../../fetcher";
import {FirstPaymentWaiverItem} from "./FirstPaymentWaiverItem";
import {rebateIdHelper} from "../../utils/utils";

export const DealPageRebates = () => {
    const { setDealStateWithUpdate, dealState, isHistorical } = useDealContext()
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const [open, setOpen] = useState(false);

    if (!dealState || !dealState.formatted_quote) return null;

    const rebates = dealState.formatted_quote.rebates.filter(r => r.amount !== '0')

    const firstPaymentWaiverAmount = dealState?.formatted_quote.first_payment_waived_amount || 0

    const totalRebatesAmount = rebates.reduce(function(accumulator, rebate) {
        if (rebate.is_applied) {
            return accumulator + Number(rebate.amount);
        } else {
            return accumulator
        }
    }, 0) + Number(firstPaymentWaiverAmount)


    return (
        <Box className={classnames("dealPageRebates", {
            mobile: isTabletOrMobile,
            open: open,
        })}>
            <Stack
                direction={'row'}
                justifyContent="space-between"
                alignItems="center"
                onClick={() => setOpen(!open)}
                style={{ cursor: 'pointer' }}
                className={'header header-row'}
            >
                <div
                    className={'header-name'}
                >
                    Rebates
                </div>
                <Stack
                    direction={'row'}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <div className={'header-amount'}>
                        <NumericFormat
                            value={totalRebatesAmount}
                            decimalScale={2}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                        />
                    </div>
                    <div>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                        >
                            <SectionChevron open={open}/>
                        </IconButton>
                    </div>
                </Stack>
            </Stack>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Table
                    size="small"
                    aria-label="simple table"
                >
                <TableHead>
                    <TableRow>
                        <TableCell
                            className={'header-cell'}
                            align="left"
                            width={isTabletOrMobile ? '70%' : '40%'}
                        >
                            Name
                        </TableCell>
                        {
                            isTabletOrMobile &&
                            <TableCell
                                className={'header-cell'}
                                align="right"
                                width={'40%'}
                            >
                                Amount
                            </TableCell>
                        }
                        {
                            !isTabletOrMobile &&
                            <React.Fragment>
                                {/* Icons column (info + stackable) — no header label */}
                                <TableCell
                                    className={'header-cell'}
                                    align="center"
                                    width={'15%'}
                                />
                                <TableCell
                                    className={'header-cell'}
                                    align="center"
                                    width={'15%'}
                                >
                                    Applied
                                </TableCell>
                                <TableCell
                                    className={'header-cell'}
                                    align="center"
                                    width={'15%'}
                                >
                                    Taxed
                                </TableCell>
                                <TableCell
                                    className={'header-cell'}
                                    align="center"
                                    width={'15%'}
                                >
                                    Amount
                                </TableCell>
                            </React.Fragment>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* Adding a rebate changes the deal — not something a
                        delivered car can do. */}
                    {!isHistorical && <CreateRebateItem
                        dealState={dealState}
                        setDealStateWithUpdate={setDealStateWithUpdate}
                    />}
                    {
                        Boolean(firstPaymentWaiverAmount) &&
                        <FirstPaymentWaiverItem firstPaymentWaiverAmount={firstPaymentWaiverAmount}/>
                    }
                    {
                        rebates.map((rebate, index) => {
                                return (
                                    <DealPageRebateItem
                                        key={rebateIdHelper(rebate)}
                                        rebate={rebate}
                                        dealState={dealState}
                                        setDealStateWithUpdate={setDealStateWithUpdate}
                                    />
                                )
                            }

                        )
                    }
                </TableBody>
            </Table>
            </Collapse>
        </Box>
    )
}